import { useCallback, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import {
  IconButton,
  LinearProgress,
  Tooltip,
} from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { sellApi } from "../../app/slices/sellSlice";
import { toast } from "react-toastify";
import NameDateSearchComponent from "../../components/customTable/NameDateSearchComponent";


export default function Sell() {
  const columnHelper = createMRTColumnHelper();
  const sliceResponse = useSelector((state) => state.sellSlice.sell.data);
  const stateLoading = useSelector(
    (state) => state.sellSlice.loading
  );

  const [showData, setShowData] = useState([]);
  // const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (sliceResponse?.length > 0) {
      const formattedData = sliceResponse.map((item) => ({
        id: item._id,
        customerRefNo: item.customerRefNo,
        statusCode: item.statusCode,
        message: item.message,
        merchantId: item.result?.data?.merchantId || "N/A",
        quantity: item?.result?.data?.quantity || "N/A",
        totalAmount: item.result?.data?.totalAmount || "N/A",
        preTaxAmount: item.result?.data?.preTaxAmount || "N/A",
        metalType: item.result?.data?.metalType || "N/A",
        rate: item.result?.data?.rate || "N/A",
        uniqueId: item.result?.data?.uniqueId || "N/A",
        transactionId: item.result?.data?.transactionId || "N/A",
        userName: item.result?.data?.userName || "N/A",
        merchantTransactionId:
          item.result?.data?.merchantTransactionId || "N/A",
        mobileNumber: item.result?.data?.mobileNumber || "N/A",
        goldBalance: item.result?.data?.goldBalance || "N/A",
        silverBalance: item.result?.data?.silverBalance || "N/A",
        accountName: item.result?.data?.bankInfo?.accountName || "N/A",
        accountNumber: item.result?.data?.bankInfo?.accountNumber || "N/A",
        ifscCode: item.result?.data?.bankInfo?.ifscCode || "N/A",
        partnerId: item.partner_id,
        partnerUsername: item.partner_username,
        createdAt: item.createdAt,
        updatedAt: item.updatedAt,
      }));

      setShowData(formattedData);
    } else {
      setShowData([]);
    }
  }, [sliceResponse]);

  const columns = [
    columnHelper.accessor("id", {
      header: "ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row?.original?.id);
          toast.success("Copied to clipboard!");
        };

        return (
          <Tooltip title={cell.row?.original?.id}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("customerRefNo", {
      header: "Customer Ref No",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.customerRefNo);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.customerRefNo}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.customerRefNo}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("userName", {
      header: "Name",
      size: 30,
    }),
    columnHelper.accessor("quantity", {
      header: "Quantity",
      size: 30,
    }),
    columnHelper.accessor("totalAmount", {
      header: "Total Amount",
      size: 30,
    }),

    columnHelper.accessor("metalType", {
      header: "Metal Type",
      size: 30,
    }),

    columnHelper.accessor("uniqueId", {
      header: "Unique ID",
      size: 30,
    }),
    columnHelper.accessor("transactionId", {
      header: "Transaction ID",
      size: 50,
    }),
    columnHelper.accessor("accountName", {
      header: "Account Name",
      size: 50,
    }),
    columnHelper.accessor("accountNumber", {
      header: "Account Number",
      size: 50,
    }),
    columnHelper.accessor("ifscCode", {
      header: "ifsc Code",
      size: 50,
    }),

    columnHelper.accessor("merchantId", {
      header: "Merchant ID",
      size: 50,
    }),
    columnHelper.accessor("mobileNumber", {
      header: "Mobile No",
      size: 30,
    }),
    columnHelper.accessor("goldBalance", {
      header: "Gold Balance",
      size: 30,
    }),
    columnHelper.accessor("silverBalance", {
      header: "Silver Balance",
      size: 30,
    }),

    columnHelper.accessor("partnerId", {
      header: "Partner ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row?.original?.partnerId);
          toast.success("Copied to clipboard!");
        };

        return (
          <Tooltip title={cell.row?.original?.partnerId}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: (cell) => cell.row.original.createdAt.split("T")[0],
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 30,
      Cell: (cell) => cell.row.original.updatedAt.split("T")[0],
    }),
  ];

  const dispatch = useDispatch();

  // Local state to manage search terms
  // const [searchTerm, setSearchTerm] = useState(""); // For name search
  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  }); // For date search

  // Memoized function to dispatch the API call with the necessary parameters
  const fetchAadharData = useCallback(() => {
    // setLoading(true);

    let params = {};
    // if (searchTerm) {
    params.name = queryParams.customerName;
    // } else if (queryParams.startDate && queryParams.endDate) {
    params.startDate = queryParams.startDate;
    params.endDate = queryParams.endDate;
    // }

    if (Object.keys(params).length > 0) {
      dispatch(sellApi(params)); // Dispatch API call even when reset (empty search term or date)
    }

    // setLoading(false);
  }, [dispatch, queryParams]);

  useEffect(() => {
    fetchAadharData();
  }, [fetchAadharData]);

  // Function to handle date search
  const handleSearchByDate = (startDate, endDate, customerName) => {
    // setLoading(true);

    setQueryParams({ startDate, endDate, customerName });
  };

  return (
    <>
     {/*  */}
      <Box>
        <Box>
          <Box
            mt={{ xs: 2, md: 0 }}
            mb={2}
            display="flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="flex-end"
          >
            <NameDateSearchComponent onSearch={handleSearchByDate} />
          </Box>
        </Box>
        <Box sx={{ margin: "auto" }}>
          <CustomTable columns={columns} data={showData} loading={stateLoading} permissionKey="fintsoTransactions"
          />
        </Box>
      </Box>
    </>
  );
}
